import { render, staticRenderFns } from "./BusinessContacts.vue?vue&type=template&id=eeec8e44&"
import script from "./BusinessContacts.vue?vue&type=script&lang=js&"
export * from "./BusinessContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports